import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const DayStartCloseList = () => {
    const [dayStartCloseData, setDayStartCloseData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch Day Start/Close data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}daystartclose`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setDayStartCloseData(data.data);
                    setFilteredData(data.data); // Set initial filtered data
                } else {
                    console.error('Failed to fetch day start/close data');
                }
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter data based on search term
        const filtered = dayStartCloseData.filter(item =>
            item.counter.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredData(filtered);
    };

    // Navigate to add entry page
    const handleAdd = () => {
        navigate('/AddDayStartClose');
    };

    // Navigate to edit entry page
    const handleEdit = (id) => {
        navigate(`/EditDayStartClose/${id}`);
    };

    // Handle deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this entry?")) {
            fetch(`${BASE_URL}daystartclose/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        // Update state after deletion
                        setDayStartCloseData(dayStartCloseData.filter(item => item.id !== id));
                        setFilteredData(filteredData.filter(item => item.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting entry:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Day Start/Close List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by Counter"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Entry</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>S.NO</th>
                                                <th>COUNTER</th>
                                                <th>TYPE</th>
                                                <th>VOUCHER DATE</th>
                                                <th>TIME</th>
                                                <th>DENOMINATION</th>
                                                <th>NUMBER</th>
                                                <th>AMOUNT</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{item.sno || index + 1}</td>
                                                    <td>{item.counter || 'N/A'}</td>
                                                    <td>{item.type || 'N/A'}</td>
                                                    <td>{new Date(item.voucher_date).toLocaleDateString() || 'N/A'}</td>
                                                    <td>{item.time || 'N/A'}</td>
                                                    <td>{item.denomination || 'N/A'}</td>
                                                    <td>{item.number || 'N/A'}</td>
                                                    <td>{item.amount || 'N/A'}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(item.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default DayStartCloseList;
